import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Button = ({onClick, text, icon})=>{
    return(
        <div style={{width:'100%', display:'flex', justifyContent:'center',}}>
            <button
                style={{
                    padding: '10px 20px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#ccc',
                    backgroundColor: '#282c34',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    marginTop: '20px',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center'
                }}
                onClick={() => onClick()}
            >
                {icon && <FontAwesomeIcon icon={icon} style={{marginRight:10}} />}
                {text && <span>{text}</span>}
            </button>
        </div>
    )
}

export default Button;